import message from './Messages';
import ItemView, { getItemUrl } from './ItemView';
import Icon from 'components/Icon';
import { connect, MapStateToProps } from 'react-redux';
import { item_createNewFolder } from 'store/providers/providerSlice';
import {
  IComponentProps as IComponentBaseProps,
  IComponentState as IComponentBaseState,
} from './ItemView';

import { getLanguageBaseOnTZ } from '../../../../utils/LanguageLocalStorage';
import { orange } from '../../../../utils/style/colors';
import i18n from '../../../../i18n';
import { IProviderItemViewWithData } from '../../../../store/providers/providerTypes';
import { getDomainAndPort } from '../../../../api/Utils';
import { setClipboard } from '../../../Tasks/TasksManagement/TaskUtils';
import notify from '../../../../components/Notify/Notify';
import { RootState } from '../../../../store/store';
import { IThisUserState } from '../../../../store/thisUser/thisUserSlice';

interface IComponentProps extends IComponentBaseProps {
  listIndex: number;
  onOpenFolder: (index: number, id: number) => void;
  onCloseFolder: (id: number) => void;
  onPasteItems: () => void;
  moveItems: IProviderItemViewWithData[];
}

interface IComponentState extends IComponentBaseState {
  activeLanguage: string;
}

interface IStateToProps {
  thisUser: IThisUserState;
}

class FolderView extends ItemView<
  IComponentProps & IStateToProps,
  IComponentState
> {
  constructor(props: IComponentProps & IStateToProps) {
    super(props);
    this.state = {
      ...this.state,
      activeLanguage: getLanguageBaseOnTZ(),
    };
  }

  deleteItemTitle(name: string) {
    return i18n.t('deleteFolderTitle', {
      ns: 'documentManager',
      folderName: name,
    });
  }
  deleteItemMessage(name: string) {
    return i18n.t('deleteFolderMessage', {
      ns: 'documentManager',
      folderName: name,
    });
  }
  onOpenFunction(item: IProviderItemViewWithData, isNewTab: boolean) {
    return (e: any) => {
      if (e?.altKey || isNewTab) {
        e.preventDefault();
        const url = getItemUrl(item);
        window.open(url, '_blank');
        return;
      }
      const listIndex = this.props.listIndex;
      this.props.onOpenFolder(listIndex + 1, item.data.id);
    };
  }
  getThumbnail() {
    return ['zip.svg', orange];
  }
  handelConfirmCreatingNewItem(item: IProviderItemViewWithData) {
    item.data.name = this.nameInput.value;
    item.data.order = this.props.expectedOrder;
    this.props.dispatch(item_createNewFolder({ item: item.data }));
  }
  getBadgeView() {
    return (
      <li>
        {i18n.language !== 'fa' ? (
          <Icon type={'chevron-right'} />
        ) : (
          <Icon type={'chevron-left'} />
        )}
      </li>
    );
  }
  newItemPlaceHolder() {
    return i18n.t('newFolderPlaceholder', { ns: 'documentManager' });
  }

  newItemTitle() {
    return i18n.t('newFolderTitle', { ns: 'documentManager' });
  }

  override deleteItem() {
    this.props.onCloseFolder(this.props.item.data.id);
    return super.deleteItem();
  }
  getMenuActions(itemId: number, editable: boolean) {
    const menuActions = super.getMenuActions(itemId, editable);
    if (
      this.props.moveItems.length > 0 &&
      editable &&
      this.props.item.data.status !== 'deleted'
    ) {
      menuActions.push({
        order: 0,
        callBack: () => {
          this.props.onPasteItems();
        },
        group: '00-context',
        icon: 'paste',
        message: message.paste,
      });
    }

    const copyItemToClipboard = (excludeSrcFolder = false) => {
      this.setState({ showDropdown: false });
      const id = this.props.item.data.id;
      const name = this.props.item.data.name;

      const url = getDomainAndPort().protocolDomain + '/man/';
      const thisUser = this.props.thisUser;
      const accessToken = thisUser.access_token;
      setClipboard(
        JSON.stringify({
          sourceItemId: id,
          remoteUrl: url,
          readAccessToken: accessToken,
          name: name,
          excludeSrcFolder: excludeSrcFolder,
          providerId: this.props.provider.id,
          companyId: this.props.provider.managingCompanyId,
        })
      );
      notify(message.linkCopiedToClipboard);
    };

    if (
      (this.props.isOwner ||
        (editable && this.props.provider.managingCompanyId === 11)) &&
      this.props.item.data.status !== 'deleted'
    ) {
      const copyContent = {
        message: i18n.t('copyFolderContent', { ns: 'documentManager' }),
        callBack: () => {
          copyItemToClipboard(true);
        },
        order: 100,
        group: '9-admin',
        icon: 'copy',
      };
      menuActions.push(copyContent);
      const copyItem = {
        message: i18n.t('copyItem', { ns: 'documentManager' }),
        callBack: () => {
          copyItemToClipboard(false);
        },
        order: 99,
        group: '9-admin',
        icon: 'copy',
      };
      menuActions.push(copyItem);
    }
    return menuActions;
  }
}

const mapStateToProps: MapStateToProps<
  IStateToProps,
  IComponentProps,
  RootState
> = (state) => {
  const thisUser = state.thisUser;
  return { thisUser };
};

export default connect(mapStateToProps, null)(FolderView);
